module.exports = __webpack_public_path__ + "img/icon6.2a7056b2.png";